// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitter-layout {
  position: absolute;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.splitter-layout .layout-pane {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  overflow: auto;
}

.splitter-layout .layout-pane.layout-pane-primary {
  flex: 1 1 auto;
}

.splitter-layout > .layout-splitter {
  flex: 0 0 auto;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  background-color: #ccc;
}

.splitter-layout .layout-splitter:hover {
  background-color: #bbb;
}

.splitter-layout.layout-changing {
  cursor: col-resize;
}

.splitter-layout.layout-changing > .layout-splitter {
  background-color: #aaa;
}

.splitter-layout.splitter-layout-vertical {
  flex-direction: column;
}

.splitter-layout.splitter-layout-vertical.layout-changing {
  cursor: row-resize;
}

.splitter-layout.splitter-layout-vertical > .layout-splitter {
  width: 100%;
  height: 4px;
  cursor: row-resize;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/splitter-layout/SplitterLayout.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".splitter-layout {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.splitter-layout .layout-pane {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 0 0 auto;\r\n  overflow: auto;\r\n}\r\n\r\n.splitter-layout .layout-pane.layout-pane-primary {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.splitter-layout > .layout-splitter {\r\n  flex: 0 0 auto;\r\n  width: 4px;\r\n  height: 100%;\r\n  cursor: col-resize;\r\n  background-color: #ccc;\r\n}\r\n\r\n.splitter-layout .layout-splitter:hover {\r\n  background-color: #bbb;\r\n}\r\n\r\n.splitter-layout.layout-changing {\r\n  cursor: col-resize;\r\n}\r\n\r\n.splitter-layout.layout-changing > .layout-splitter {\r\n  background-color: #aaa;\r\n}\r\n\r\n.splitter-layout.splitter-layout-vertical {\r\n  flex-direction: column;\r\n}\r\n\r\n.splitter-layout.splitter-layout-vertical.layout-changing {\r\n  cursor: row-resize;\r\n}\r\n\r\n.splitter-layout.splitter-layout-vertical > .layout-splitter {\r\n  width: 100%;\r\n  height: 4px;\r\n  cursor: row-resize;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
